import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom, provideBrowserGlobalErrorListeners, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { CustomTheme } from './features/layout/presets/theme';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { refreshTokenInterceptor } from './core/interceptors/refresh-token.interceptor';
import { errorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { networkErrorInterceptor } from './core/interceptors/network-error.interceptor';
import { appRequestMetadataInterceptor } from './core/interceptors/app-request-metadata.interceptor';
import { NetworkStatusService } from './core/services/network-status/network-status.service';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { JwtModule } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { PreloadService } from './core/services/preload/preload.service';
import { SignalRService } from './core/services/signalr/signalr.service';

export function tokenGetter() {
  return sessionStorage.getItem('token-pal');
}

export function initializePreload() {
  return () => {
    const preloadService = inject(PreloadService);
    preloadService.preloadCriticalAssets();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    DialogService,
    MessageService,
    ConfirmationService,
    provideBrowserGlobalErrorListeners(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializePreload,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const networkStatus = inject(NetworkStatusService);
        return () => Promise.resolve();
      },
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const signalRService = inject(SignalRService);
        return () => {
          return signalRService.startTransactionHub().catch(() => Promise.resolve());
        };
      },
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const signalRService = inject(SignalRService);
        return () => {
          return signalRService.startNotificationHub().catch(() => Promise.resolve());
        };
      },
      multi: true,
    },
    provideRouter(
      routes,
      withViewTransitions(),
      withComponentInputBinding()
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        appRequestMetadataInterceptor,
        authInterceptor,
        refreshTokenInterceptor,
        errorHandlerInterceptor,
        networkErrorInterceptor,
      ])
    ),
    provideLottieOptions({
      player: () => player,
    }),
    providePrimeNG({
      theme: {
        preset: CustomTheme,
        options: {
          darkModeSelector: true,
        }
      },
    }),
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter
        }
      }),
      CookieService
    ),
  ],
};
